var SCREEN_WIDTH = window.innerWidth; // Get the initial screen width
const RESPONSIVE_BREAKPOINT = {
    DESKTOP: 990,
    TABLET: 750,
    MOBILE: 375
}

// Search input focus in modal
function toggleFocusSearch() {
    document.querySelectorAll('.header-search__input-interface').forEach(function (headerSearchInput) {
        const detailsElement = headerSearchInput.closest('.header__search details');
        const searchInModalInput = detailsElement && detailsElement.querySelector('.search__input');

        if (!detailsElement || !searchInModalInput) return;

        headerSearchInput.addEventListener('click', function () {
            // Create a MutationObserver to watch for changes to the details element
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.attributeName === 'open') {
                        // Focus the input when the details element is opened
                        if (detailsElement.hasAttribute('open')) {
                            searchInModalInput.focus();
                            // Disconnect the observer once the input is focused
                            observer.disconnect();
                        }
                    }
                });
            });

            // Configure the observer to watch for attribute changes
            observer.observe(detailsElement, { attributes: true });
        });
    });
}

// Mega menu open on hover
function toggleMegaMenuWhenHover() {
    const menuItems = document.querySelectorAll('.header-wrapper .mega-menu');

    if (menuItems.length) {
        const header = menuItems[0].closest('header');
        const isMiddleLeft = header.classList.contains('header--middle-left');
        const isUSHeader = header.classList.contains('header--us');

        if (!isMiddleLeft && !isUSHeader) {
            menuItems.forEach(function (item) {
                item.addEventListener('mouseover', function () {
                    item.setAttribute('open', true);
                });

                item.addEventListener('mouseout', function () {
                    item.removeAttribute('open');
                });
            });
        }
    }
}

function addEventForMegaMenuItem() {
    const menuItems = document.querySelectorAll('.header__inline-menu .mega-menu > .header__menu-item');

    if (menuItems.length) {
        const header = menuItems[0].closest('header');
        const isMiddleLeft = header.classList.contains('header--middle-left');
        const isUSHeader = header.classList.contains('header--us');

        menuItems.forEach(function (item) {
            if (!isMiddleLeft && !isUSHeader) {
                item.addEventListener('click', function (event) {
                    event.preventDefault();
                });
            }

            item.addEventListener('dblclick', function (event) {
                event.preventDefault();;
                event.stopPropagation();

                const href = item.getAttribute('data-href');

                if (href) {
                    window.location.href = href;
                }
            });
        });
    }
}

// Update the SCREEN_WIDTH variable when the window is resized
function updateScreenWidth() {
    SCREEN_WIDTH = window.innerWidth;
}

// Handle click event on footer menu
function handleFooterMenuClick(event) {
    if (SCREEN_WIDTH > 749) {
        event.preventDefault();
        event.stopPropagation();
    }
}

// Force footer menu to be open and disable click event on on desktop
function forceFooterMenuOpenOnDesktop() {
    const menuList = document.querySelectorAll('.footer-block--menu');

    if (menuList) {
        menuList.forEach(function (menu) {
            const summary = menu.querySelector('summary');

            if (SCREEN_WIDTH > 749) {
                menu.setAttribute('open', true);
                summary.addEventListener('click', handleFooterMenuClick);
            } else {
                menu.removeAttribute('open');
                summary.removeEventListener('click', handleFooterMenuClick);
            }
        });
    }
}

// Handle resize event
function handleResize() {
    updateScreenWidth();
    forceFooterMenuOpenOnDesktop();
}

function initProcessBar() {
    setTimeout(() => {
        const processBars = document.querySelectorAll('.process-bar-trigger');

        if (processBars) {
            processBars.forEach((item) => {
                item.style.width = parseFloat(item.dataset['width']) + '%';
            });
        }
    }, 200);
}

function checkIfTotalPriceChange() {
    const miniCartTotalPrice = document.querySelector('#CartDrawer');
    const cartTotalPrice = document.querySelector('#main-cart-footer');
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList' || mutation.type === 'subtree' || mutation.type === 'attributes') {
                initProcessBar();
            }
        });
    });

    observer.observe(miniCartTotalPrice, { childList: true, subtree: true, attributes: true });

    if (cartTotalPrice) {
        observer.observe(cartTotalPrice, { childList: true, subtree: true, attributes: true });
    }
}

function setMegaMenusWidth() {
    if (SCREEN_WIDTH >= RESPONSIVE_BREAKPOINT.DESKTOP) {
        const header = document.querySelector('header');
        if (!header.classList.contains('header--middle-left')) return;

        const headerMiddle = header.querySelector('.header-middle');
        if (!headerMiddle) return;

        const headerLogo = headerMiddle.querySelector('.header__heading');
        const megaMenus = headerMiddle.querySelectorAll('.mega-menu');
        if (!headerLogo || !megaMenus.length) return;

        const headerMiddleWidth = parseFloat(headerMiddle.offsetWidth);
        const headerLogoWidth = parseFloat(headerLogo.offsetWidth);
        const headerMiddlePadding = parseFloat(window.getComputedStyle(headerMiddle).paddingLeft) || 0;
        const totalWidth = headerMiddleWidth - headerLogoWidth - headerMiddlePadding;

        megaMenus.forEach((menu) => {
            const menuList = menu.querySelector('.mega-menu__list');

            if (menuList) {
                menuList.style.paddingLeft = `${headerMiddleWidth - totalWidth}px`;
            }
        });
    }
}

function handleNewsletterFormSubmit() {
    const form = document.getElementById('ContactFooter');
    if (!form) return;

    const emailInput = form.elements['contact[email]'];
    const nameInput = form.elements.display_name;
    const errorEl = form.querySelector('#ContactFooter-error');
    const errorText = errorEl && errorEl.querySelector('.newsletter-form__error-text');
    const emailPattern = /[^\s@]+@[^\s@]+\.[^\s@]+/;

    const isValidEmail = function (value) {
        return emailPattern.test((value || '').trim());
    };

    const isValidName = function (value) {
        return Boolean((value || '').trim());
    };

    const setFieldInvalid = function (input, isInvalid) {
        if (!input) return;

        if (isInvalid) {
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', 'ContactFooter-error');
        } else {
            input.removeAttribute('aria-invalid');
            input.removeAttribute('aria-describedby');
        }
    };

    const showFieldErrors = function () {
        const emailInvalid = emailInput && !isValidEmail(emailInput.value);
        const nameInvalid = nameInput && !isValidName(nameInput.value);
        let message = '';

        if (emailInvalid && nameInvalid) {
            message = (errorEl && errorEl.dataset.emailAndNameError) || 'Please enter a valid email address and name';
        } else if (emailInvalid) {
            message = emailInput.dataset.emailError || 'Please enter a valid email address';
        } else if (nameInvalid) {
            message = nameInput.dataset.nameError || 'Please enter your name';
        }

        if (errorEl) {
            errorEl.classList.toggle('hidden', !message);
            if (errorText) errorText.textContent = message;
        }

        if (message) {
            const successEl = document.getElementById('ContactFooter-success');
            if (successEl) {
                successEl.classList.add('hidden');
                successEl.setAttribute('hidden', '');
                successEl.style.display = 'none';
            }
        }

        setFieldInvalid(emailInput, emailInvalid);
        setFieldInvalid(nameInput, nameInvalid);
    };

    [emailInput, nameInput].forEach(function (input) {
        if (!input) return;

        input.addEventListener('invalid', function (e) {
            e.preventDefault();
            showFieldErrors();
        });
    });

    form.addEventListener('submit', function (e) {
        const emailInvalid = emailInput && !isValidEmail(emailInput.value);
        const nameInvalid = nameInput && !isValidName(nameInput.value);

        if (emailInvalid || nameInvalid) {
            e.preventDefault();
            showFieldErrors();
            return;
        }

        const firstNameInput = form.elements['contact[first_name]'];
        const lastNameInput = form.elements['contact[last_name]'];

        if (nameInput && nameInput.value && firstNameInput && lastNameInput) {
            const nameParts = nameInput.value.trim().split(/\s+/);
            if (nameParts.length > 0) {
                firstNameInput.value = nameParts[0];
                lastNameInput.value = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
            }
        }
    });
}

// Run the function when the DOM is ready
document.addEventListener('DOMContentLoaded', function () {
    toggleFocusSearch();
    toggleMegaMenuWhenHover();
    addEventForMegaMenuItem();
    forceFooterMenuOpenOnDesktop();
    initProcessBar();
    checkIfTotalPriceChange();
    setMegaMenusWidth();
    handleNewsletterFormSubmit();

    window.addEventListener('resize', handleResize);
});
